import { render, staticRenderFns } from "./GnbTop.vue?vue&type=template&id=2229bd80&scoped=true&"
import script from "./GnbTop.vue?vue&type=script&lang=js&"
export * from "./GnbTop.vue?vue&type=script&lang=js&"
import style0 from "./GnbTop.vue?vue&type=style&index=0&id=2229bd80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229bd80",
  null
  
)

export default component.exports